import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.auth.getToken();
    const authReq = token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    if (token) {
      console.log('%c[TokenInterceptor] ✅ Attaching token to request:', 'color: green', token);
    } else {
      console.warn('%c[TokenInterceptor] ⚠️ No token found on request:', 'color: orange', req.url);
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const isAuthLoginRequest = req.url.toLowerCase().includes('/auth/login');
          this.auth.logout();
          if (!isAuthLoginRequest) {
            this.router.navigate(['/auth/login']);
          }
        }

        return throwError(() => error);
      })
    );
  }
}
